import React from 'react';
import { connect } from 'react-redux';

import { Form, Field } from 'react-final-form';
import { Button } from '@material-ui/core';
import { priceRequestMessage } from '../../Actions/priceRequestMessage';
import Input from '../../components/Input/Input';
import schema from './schema';
import validate from '../../utilities/validate';
import s from './CartForm.module.scss';
import { REQUEST } from '../../actionTypes';

const PriceForm = props => {
  const { t, sendRequestMessage, requestMessage, goodId, goodName } = props;

  const normalizePhone = value => {
    if (!value) return value;
    const phone = value.replace(/[^\d+]/g, '');
    return `${phone.substring(0, 1)}${phone.slice(1).replace(/\+/g, '')}`;
  };

  const onSubmit = value => {
    sendRequestMessage({ ...value, phone: normalizePhone(value.phone) });
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={value =>
        validate({ ...value, phone: normalizePhone(value.phone) }, schema, {})
      }
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={s.form}>
          <div className={s.formContent}>
            <Field
              autoFocus
              name="name"
              label={`${t['Имя']} *`}
              component={Input}
            />
            <Field
              name="phone"
              label={`${t['Телефон']} *`}
              component={Input}
              type="tel"
              format={normalizePhone}
              // placeholder="(999) 999-9999"
            />
            <Field name="email" label="Email *" component={Input} />
            <Field
              name="goodId"
              component="input"
              type="hidden"
              defaultValue={goodId}
            />
            <Field
              name="goodName"
              component="input"
              type="hidden"
              defaultValue={goodName}
            />
            <div className={s.formBtn}>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                type="submit"
                disabled={requestMessage.state === REQUEST}
              >
                {t['Отправить запрос']}
              </Button>
            </div>
          </div>
        </form>
      )}
    </Form>
  );
};

const mapStateToProps = state => ({
  t: state.translation,
  requestMessage: state.priceRequestMessage
});

const mapDispatchToProps = {
  sendRequestMessage: priceRequestMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceForm);
